export default __webpack_public_path__ + "static/media/policies_procedure_blue.ee7b01e5.png";